export default __webpack_public_path__ + "media/images/images_v2/actleft-eef0b37066e269b119e19261703c64fe.png";